import React, { Fragment } from 'react';
import { AFTER_APP } from 'Components/frameworks/portal/Portal.constants';
import { renderInfoBanner } from 'Components/widgets/info-banner/infoBanner.utils';
import type { InfoBannerData } from 'Components/widgets/info-banner/infoBanner.query';
import 'Components/widgets/info-banner/infoBanner.query';
import { t } from 'Src/i18n';
import { Title } from 'Components/frameworks/title/Title';
import { ProposalActivitiesBooking } from 'Components/widgets/activities-booking/ProposalActivitiesBooking';
import { ProposalRentalsBooking } from 'Components/widgets/rentals-booking/ProposalRentalsBooking';
import { useBookingNavbar } from 'Components/widgets/booking-navbar/useBookingNavbar';
import { useBookingNavbarContext } from 'Components/widgets/booking-navbar/BookingNavbarContext';
type Props = {
  infoBannerData: InfoBannerData;
  proposals: ReadonlyArray<Proposal>;
  resort: Product;
  selectedProposal: Proposal;
  proposals: ReadonlyArray<Proposal>;
  infoBannerData: InfoBannerData;
};
export const ActivitiesView = ({ infoBannerData, proposals, resort, selectedProposal }: Props) => {
  const { navbarRef } = useBookingNavbarContext();
  const hasRentals = Boolean(resort?.rentalsTree?.length);
  useBookingNavbar({
    noEdit: false,
    portalPosition: AFTER_APP,
    navbarRef,
  });
  return (
    <Fragment>
      {renderInfoBanner({
        infoBannerData,
        departureDate: selectedProposal.departureDate,
        arrivalDate: selectedProposal.arrivalDate,
        currentStep: 'activities',
      })}
      <Title className="mb-30" dataTestId="Activities-title" theme="title-brand-n2">
        {t('common.activities.activitiesUpsellTitle', {
          productName: resort?.name,
        })}
      </Title>
      {hasRentals && (
        <ProposalRentalsBooking
          className="mb-20"
          data-testid="rentals"
          forwardRef={navbarRef}
          proposals={proposals}
          rentals={resort.rentalsTree}
          selectedProposal={selectedProposal}
        />
      )}
      <ProposalActivitiesBooking
        categories={resort.activityTree}
        forwardRef={navbarRef}
        hasRentals={hasRentals}
        proposals={proposals}
        resort={resort}
        selectedProposal={selectedProposal}
        thematics={resort.thematicActivityTree}
      />
    </Fragment>
  );
};
